export default __webpack_public_path__ + "static/viinitie-banner-xmass-desktop-extra-wide.2b42a5e266d1a29e6c704a861a7f7086.webp";